import type { ClinicInfoItem } from "../api/clinicInfo";

export function toMap(items: ClinicInfoItem[]) {
  const map: Record<string, string> = {};
  for (const it of items) map[it.name] = it.detail;
  return map;
}
